<template>
  <div class="page-main">
    <div>
      <div class="flex flex-y-center flex-x-between m-b-10">
        <div class="flex flex-y-center">
          <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="searchListData">
            <span>订单交期:</span>
            <e-date-picker
              type="daterange"
              :value.sync="jiao_huo_ri_qi"
              isShowFast
              @change="searchListData"
            />
          </el-form>
        </div>
      </div>
      <!-- 表格 -->
      <vxe-grid
        ref="refTable"
        :show-footer="!!tableData.length"
        :loading="loading"
        :columns="tableColumn"
        :data="tableData"
        :height="this.$util.getViewHeight() - 36 - 148"
        :footer-method="footerMethod"
        :cell-class-name="cellClassName"
        @cell-dblclick="itemDbDo"
        @resizable-change="handleColumnResize"
        @keydown="tableKeydown"
        @current-change="tableCurrentChange"
      >
        <!-- slot_default -->
        <!-- resultStart -->
        <template #default_bill_code="{ row }">
          <el-link type="primary" @click="itemDo(row.bill_id)">
            {{ row.bill_code }}
          </el-link>
          <el-link :type="row.status_str === '已完结' ? 'success' : 'primary'">
            ({{ row.status_str }})
          </el-link>
        </template>
        <template #default_zhi_zao_ming_xi="{ row }">
          <el-link type="primary" @click="itemMadeDetail(row.bill_id)">
            <div class="flex flex-y-center">
              <span class="iconfont icon-dingdan f-s-12"></span>
              <span>制造明细</span>
            </div>
          </el-link>
        </template>
        <template #default_zhi_zao_liu_cheng="{ row }">
          <el-link type="primary" @click="itemMadeView(row.bill_id)">
            <div class="flex flex-y-center">
              <span class="iconfont icon-ziliucheng f-s-12"></span>
              <span class="m-l-2">制造流程</span>
            </div>
          </el-link>
        </template>
        <template #default_jiao_huo_ri_qi="{ row }">
          <div>{{ row.jiao_huo_ri_qi || '-' }}</div>
          <div class="c-orange">{{ row.jiao_huo_ri_qi_str }}</div>
        </template>
        <template #default_list_chan_pin_tu="{ row }">
          <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
        </template>

        <!-- resultOrderNo -->
        <template #default_list_gong_cheng_tu="{ row }">
          <e-upload-image
            v-if="row.list_gong_cheng_tu"
            :list.sync="row.list_gong_cheng_tu"
            disabled
          />
        </template>
        <template #default_list_yuan_wen_jian="{ row }">
          <e-upload-file
            v-if="row.list_yuan_wen_jian"
            :list.sync="row.list_yuan_wen_jian"
            disabled
          />
        </template>
        <template #default_list_jian_ce_mu_ban="{ row }">
          <e-upload-file
            v-if="row.list_jian_ce_mu_ban"
            :list.sync="row.list_jian_ce_mu_ban"
            disabled
          />
        </template>
        <template #default_list_jian_ce_bao_gao="{ row }">
          <e-upload-file
            v-if="row.list_jian_ce_bao_gao"
            :list.sync="row.list_jian_ce_bao_gao"
            disabled
          />
        </template>
        <template #default_jin_du="{ row }">
          <div class="flex flex-center">
            <div
              class="flex flex-y-center"
              v-for="(item, index) in diffSearchTypeShowData.list"
              :key="index"
            >
              <span v-if="index">-</span>
              <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
              <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
              <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
            </div>
          </div>
        </template>

        <!-- resultEnd -->
        <template #default_operate="{ row }">
          <el-dropdown>
            <el-button type="default" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="itemDo(row.id)">
                <span class="c-blue">编辑</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="itemPrint(row)"> 打印 </el-dropdown-item>
              <el-dropdown-item @click.native="itemDelete(row)">
                <span class="c-red">删除</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

        <!-- slot_pager -->
        <template #pager>
          <div></div>
          <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
        </template>
      </vxe-grid>
    </div>

    <!-- 弹窗-核算单 -->
    <PopupDo
      v-if="isShowPopupDo"
      :show.sync="isShowPopupDo"
      :detailId="activeDetailId"
      @success="updatePage"
    />

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="activeBillId"
      :isVerify="false"
    />

    <!-- 弹窗-制造流程 -->
    <b-popup-verify-goods-view
      v-if="isShowPopupVerifyGoodsView"
      :show.sync="isShowPopupVerifyGoodsView"
      :id="activeBillId"
      :isVerify="false"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_renwu_page_list',
  components: {
    PopupDo: () => import('../common/popup-do/index')
  },
  data() {
    return {
      // loading
      loading: true,

      // filter
      jiao_huo_ri_qi: [this.$util.getDate().monthStart, this.$util.getDate().monthEnd],

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },

      // popup
      isShowPopupDo: false,
      isShowPopupVerifyGoodsDetail: false,
      isShowPopupVerifyGoodsView: false,
      activeBillId: null,
      activeDetailId: null
    }
  },
  computed: {
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 表格列
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '工单编号',
          field: 'gong_dan_code'
        },
        {
          title: '销售单号',
          field: 'bill_code'
        },
        {
          title: '设备',
          field: 'shebei_name'
        },
        {
          title: '负责人',
          field: 'fu_ze_ren_name'
        },
        {
          title: '订单交期',
          field: 'jiao_huo_ri_qi',
          formatter: ({ row }) => {
            return row.jiao_huo_ri_qi ? row.jiao_huo_ri_qi.slice(0, 10) : '-'
          }
        },
        {
          title: '生产交期',
          field: 'sheng_chan_end_date',
          formatter: ({ row }) => {
            return row.sheng_chan_end_date ? row.sheng_chan_end_date.slice(0, 10) : '-'
          }
        },
        {
          title: '工艺图片',
          field: 'list_chan_pin_tu',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '工艺名称',
          field: 'name',
          width: 120
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 120
        },
        {
          title: '单位',
          field: 'unit',
          width: 60
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        },
        {
          title: '领料数',
          field: 'get_counts'
        },
        {
          title: '报工数',
          field: 'sheng_chan_end_counts'
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' }
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' }
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' }
        },
        {
          title: '操作',
          slots: { default: 'default_operate' },
          width: 120
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 更新页面
    updatePage() {
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        jiao_huo_ri_qi: this.jiao_huo_ri_qi || []
      }

      this.$api({
        method: 'post',
        url: '/admin/gcvip/shengChanGongDan/list',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.dai_shou_li_count = res.data.dai_shou_li_count
            this.totalObj.shou_li_zhong_count = res.data.shou_li_zhong_count
            this.totalObj.yi_wan_jie_count = res.data.yi_wan_jie_count
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'bill_id')
      return result
    },

    // 项-制造明细
    itemMadeDetail(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsDetail = true
    },
    // 项-制造流程
    itemMadeView(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsView = true
    },
    // 项-增改
    itemDo(id) {
      this.activeDetailId = id
      this.isShowPopupDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.id)
    },
    // 项-打印制造流程
    itemPrint(row) {
      let url = `/new/renwu/print?id=${row.id}`
      window.open(url, '_blank')
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm(`工单编号：${row.gong_dan_code}，是否删除该工单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(row.id)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/shengChanGongDan/delete',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('操作成功')
            this.getListData()
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
